import { ArrowUp, ArrowDown, ArrowUpDown, type LucideIcon } from 'lucide-react';

interface SortHeaderProps<K extends string> {
  readonly label: string;
  readonly sortKey: K;
  readonly active: K | null;
  readonly direction: 'asc' | 'desc';
  readonly onSort: (key: K) => void;
  readonly align?: 'left' | 'right';
}

export function SortHeader<K extends string>({
  label,
  sortKey,
  active,
  direction,
  onSort,
  align = 'left',
}: SortHeaderProps<K>): React.JSX.Element {
  const isActive: boolean = active === sortKey;
  let Icon: LucideIcon = ArrowUpDown;
  let ariaSortValue: React.AriaAttributes['aria-sort'] = 'none';
  if (isActive) {
    Icon = direction === 'asc' ? ArrowUp : ArrowDown;
    ariaSortValue = direction === 'asc' ? 'ascending' : 'descending';
  }
  const handleClick = (): void => {
    onSort(sortKey);
  };
  return (
    <th aria-sort={ariaSortValue} className={`px-6 py-3 ${align === 'right' ? 'text-right' : ''}`}>
      <button
        type="button"
        onClick={handleClick}
        className={`inline-flex items-center gap-1 uppercase font-semibold hover:text-foreground transition-colors ${
          isActive ? 'text-foreground' : ''
        }`}
      >
        <span>{label}</span>
        <Icon size={12} className={isActive ? 'opacity-100' : 'opacity-40'} />
      </button>
    </th>
  );
}
